import { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { LocationSearchBox } from './locationSearchBox.tsx';
import { KeywordSearchBox } from './KeywordSearchBox.tsx';
import { closeiOSKeyboard } from '../utils/iOS.js';
import type { SearchCallbacks } from '../search/types/searchPage';
import type { FilterCategory } from '../search/types/searchFilter';

interface SearchBoxesProps {
    searchURL: string;
    baseSearchURL: string;
    callbacks: SearchCallbacks;
    detectedLocation?: object;
    filterCategories?: FilterCategory[];
    extraFilters?: FilterCategory[];
    projects?: object;
    showBrowseLink?: boolean;
    placeholder?: string;
}

export class SearchBoxes extends PureComponent<SearchBoxesProps> {
    static propTypes = {
        searchURL: PropTypes.string.isRequired,
        baseSearchURL: PropTypes.string.isRequired,
        callbacks: PropTypes.objectOf(PropTypes.func).isRequired,
        detectedLocation: PropTypes.object,
        filterCategories: PropTypes.array,
        extraFilters: PropTypes.array,
        projects: PropTypes.object,
        showBrowseLink: PropTypes.bool,
        placeholder: PropTypes.string,
    };

    private readonly keywordsRef = createRef<KeywordSearchBox>();
    private readonly locationRef = createRef<LocationSearchBox>();

    browseLink() {
        if (!this.props.showBrowseLink) {
            return '';
        } else {
            return (
                <a className="browse-funded" href={this.props.baseSearchURL + '?historical=true&featured=true'}>Browse A+ Projects</a>
            );
        }
    }

    /**
     * Trigger searches on all boxes in this "form"
     */
    search = () => {
        closeiOSKeyboard();
        window.dcAnalytics.trackOptX('submitsearch');
        const keywordsURL = this.makeKeywordsURL();
        this.locationRef.current?.submit(keywordsURL);
    };

    makeKeywordsURL = () => {
        return this.keywordsRef.current?.makeURL(false, false) ?? '';
    };

    render() {
        const props = this.props;
        return (
            <div className="form-redux search-area">
                <KeywordSearchBox {...props} searchAll={this.search} ref={this.keywordsRef} />
                <LocationSearchBox {...props} searchAll={this.search}
                    makeKeywordsURL={this.makeKeywordsURL} ref={this.locationRef} />
                {/* js-click-on-enter adds the key events, but ESLint doesn't realize that */}
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                <div tabIndex={0} role="button" className="button-secondary js-click-on-enter" onClick={this.search}>
                        Search
                </div>
                {this.browseLink()}
            </div>
        );
    }
}
